import React, { useEffect, useState } from 'react';
import './Confetti.css';

const COLORS = ['#f59e0b', '#c4788a', '#2d6b4a', '#4a8ab5', '#a88dab', '#e94560', '#ff6b6b', '#ffd93d'];

function createParticle(i) {
  return {
    id: i,
    x: Math.random() * 100,
    delay: Math.random() * 0.8,
    duration: 1.5 + Math.random() * 2,
    size: 6 + Math.random() * 8,
    color: COLORS[Math.floor(Math.random() * COLORS.length)],
    rotation: Math.random() * 360,
    type: Math.random() > 0.5 ? 'circle' : 'rect',
  };
}

export default function Confetti({ active, onDone }) {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    if (active) {
      setParticles(Array.from({ length: 60 }, (_, i) => createParticle(i)));
      const timer = setTimeout(() => {
        setParticles([]);
        if (onDone) onDone();
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [active, onDone]);

  if (particles.length === 0) return null;

  return (
    <div className="confetti-container">
      {particles.map(p => (
        <div
          key={p.id}
          className={'confetti-particle confetti-' + p.type}
          style={{
            left: p.x + '%',
            width: p.size,
            height: p.type === 'rect' ? p.size * 0.6 : p.size,
            background: p.color,
            animationDelay: p.delay + 's',
            animationDuration: p.duration + 's',
            transform: 'rotate(' + p.rotation + 'deg)',
          }}
        />
      ))}
    </div>
  );
}